import HeaderArticle from "../../../components/articles/HeaderArticle/HeaderArticle";
import ContentArticle from "../../../components/articles/ContentArticle/ContentArticle";

export default function OTCyberSecurity() {
  const headerProps = {
    title: "OT Cyber Security Is Different",
    titleWidth: "600px",
    description: <>Cybercrime could be a highly lucrative activity. Information could be stolen and sold, operations could be disrupted as paid criminal service or an entire company could be taken hostage for ransom. As soon as a company has value, it becomes a potential target for Cybercrime. <br/><br/> Recent development in digitalization and Industry 4.0 likely render OT environments not only defenseless against Cybercrime, but could even create a hard-to-close backdoor into your digital organization! IT Cyber Security applied within the OT environment will proof to be a poor fit. This is why OT Cyber Security must be approached correctly and prioritized at C-level.</>,
    url: "https://www.aivhy.com/articles/ot-cyber-security",
    image: "https://www.aivhy.com/images/logos/LOGO_AIVHY.webp",
    imageHeader: "/images/industries/machine.webp",
    tableOfContents: [
      { title: "The IT attack surface", link: "the-it-attack-surface" },
      { title: "Emerging risks and cybercrime", link: "emerging-risks-and-cybercrime" },
      { title: "IT-led security measures and consequences", link: "it-led-security-measures-and-consequences" },
      { title: "What went wrong?", link: "what-went-wrong" },
    ],
    readMore: [
      { title: "A comprehensive guide to Real-World Industry 4.0", subTitle: "Industry 4.0 holds an exciting future. A future that poses entirely new sources of business value and revenue. A disruptive transformation where organizations enter the 4th industrial revolution and leave their competitors behind through digitalization, integration, auto(no)mation, and insight.", link: "/articles/guide-to-real-world-industry-4-0" },
      { title: "What is Operational Technology (OT)?", subTitle: "Operational Technology (OT) is hardware with a digital or electronical core or software, that interacts with the physical world. This interaction includes sensing, actuating, direct monitoring and direct control of physical systems and processes.", link: "/articles/what-is-operational-technology" },
      { title: "Real-World Industry 4.0", subTitle: "Industry 4.0, an exciting future of digitalization, integration, and auto(no)mation. A future where organizations gain significant competitive advantage or fall behind. But what is Industry 4.0 exactly and what does it look like in the real world. Which challenges are there to overcome and how to do this? This article provides an understanding in real-world Industry 4.0, lists achievable examples, and discusses the challenges that one most likely will encounter during the transformation. And finally, the article will introduce a comprehensive approach to the real-world Industry 4.0 transformation.", link: "/articles/real-world-industry-4-0" },
    ]
  };

  const theITAttackSurface = {
    content: [
      { type: "title", value: "The IT Attack Surface", link: "the-it-attack-surface" },
      { 
        type: "text", 
        value: "The IT environment is often connected to the world wide web and applies a high degree of standardization, resulting in an ideal cyber-attack surface. Because of this, Cyber Security is one of the main pillars within the IT. Operational Technology (OT) in contrast finds itself to be much more tailored and traditionally to be digitally disconnected. [Digitalization, IoT and Industry 4.0](/expertise/industrial4-0) are about to change that."
      },
      { 
        type: "text", 
        value: "Industry 4.0 reveals its immense value and becomes a must to maintain a competitive edge. Companies start to interconnect their OT systems, both within the OT environment as to the IT environment. New opportunities arise, but not without risk."
      }
    ],
  };

  const emergingRisksAndCybercrime = {
    content: [
      {
        type: "title",
        value: "Emerging Risks and Cybercrime",
        link: "emerging-risks-and-cybercrime"
      },
      {
        type: "text",
        value: "Cybercrime will most likely choose the path of least resistance. The newly interconnected OT environment could become part of this critical path, as OT systems were not optimized for Cyber Security. A short web search will reveal an increase in OT related cyber incidents."
      },
      {
        type: "text",
        value: "Digital exposure of OT systems requires new Cyber Security measures and cooperation between IT and OT engineers. Entirely new challenges emerge from this interconnecting transformation, as IT and OT environments have very different needs and priorities."
      }
    ],
  };

  const ITLedSecurityMeasures = {
    content: [
      {
        type: "title",
        value: "IT-led security measures and consequences",
        link: "it-led-security-measures-and-consequences"
      },
      {
        type: "text",
        value: "The IT department likely takes the lead, introducing Cyber Security within the OT environment. Legacy operating systems are banned, engineers local administrator rights are revoked, access rights are restricted, automated patch management was introduced and the operational network became managed by the IT department. All proven and logical choices, but not long before the OT environment starts fighting back."
      },
      {
        type: "text",
        value: "The Mean Time To Repair spikes as engineers can’t do their work properly and the Mean Time Between Failure plummets as systems seem to randomly fail after automated patches. A worrying amount of exceptions on the just introduced Cyber Security policies were introduced as OT systems just won’t work on the new operating systems and set standards."
      }
    ]
  };

  const WhatWentWrong = {
    content: [
      {
        type: "title",
        value: "What went wrong?",
        link: "what-went-wrong"
      },
      {
        type: "text",
        value: "OT systems are different to IT systems and the OT environment has different needs than the IT environment. This does not mean that Cyber Security is a utopia for the OT environment, but should be implemented with Cyber Security, OT and IT needs in mind. To achieve a balanced, connected and Cyber Secure OT environment, a different expertise and approach is required."
      },
      {
        type: "text",
        value: "AIVHY is experienced in OT Cyber Security and understands IT, OT and business needs. Our consultants and engineers speak IT, OT and business language, ensuring for the best solution aligning with your business goals."
      },
      {
        type: "text",
        value: "We would love to join you for a coffee with Stroopwafels and see what AIVHY can do for you."
      }
    ]
  }
  
  return (
    <>
      <HeaderArticle {...headerProps} />
      <ContentArticle {...theITAttackSurface} />
      <ContentArticle {...emergingRisksAndCybercrime} />
      <ContentArticle {...ITLedSecurityMeasures} />
      <ContentArticle {...WhatWentWrong} />
    </>
  );
}